/**
 * @file: Eyebrow.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * A light section label in the lead-detail voice — steel ink, generous lead-in,
 * with an optional red asterisk for required sections.
 */

import { Typography } from '@euler/app/components/typography';
import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { View } from 'react-native';

export const Eyebrow = ({
  children,
  first,
  required,
}: {
  children: React.ReactNode;
  first?: boolean;
  required?: boolean;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: first ? rpx(4) : rpx(22),
        marginBottom: rpx(10),
      }}
    >
      <Typography.Text size={rpx(13)} color={LD.steel} bold>
        {children}
      </Typography.Text>
      {required ? (
        <Typography.Text
          size={rpx(13)}
          color={LD.danger}
          style={{ marginLeft: rpx(3) }}
        >
          *
        </Typography.Text>
      ) : null}
    </View>
  );
};
